import styled from 'styled-components';
import { ErrorText } from '../../styles/chime-react/CommonStyles';

export const StyledIconWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
`;

export const StyledErrorText = styled(ErrorText)`
  font-size: ${(props) => props.theme.fontSizes.text.fontSize};
  line-height: ${(props) => props.theme.fontSizes.text.lineHeight};
  font-weight: bold;
`;

export const StyledWorkaroundContent = styled.div`
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  background-color: ${(props) => props.theme.colors.primary.light};

  & {
    .title {
      margin-bottom: 0.75rem;
      font-size: ${(props) => props.theme.fontSizes.text.fontSize};
      line-height: ${(props) => props.theme.fontSizes.text.lineHeight};
      font-weight: bold;
    }
    .step {
      margin-top: 0.25rem;
      font-size: ${(props) => props.theme.fontSizes.small.fontSize};
      line-height: ${(props) => props.theme.fontSizes.small.lineHeight};
      display: grid;
      grid-template-columns: auto 1fr;
      column-gap: 0.25rem;
    }
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    & {
      .title {
        font-size: ${(props) => props.theme.fontSizes.h6.fontSize};
        line-height: ${(props) => props.theme.fontSizes.h6.lineHeight};
      }
      .step {
        font-size: ${(props) => props.theme.fontSizes.text.fontSize};
        line-height: ${(props) => props.theme.fontSizes.text.lineHeight};
      }
    }
  }
`;
